import React, {Component, Fragment} from "react";
import * as messageConstants from "../../shared/messages";
import {DeleteIntegrationButton} from "./DeleteIntegrationButton";
import './index.scss';

export class AzureAdTable extends Component {
  render() {
    const {
      azureAdList,
      deleteAzureAd
    } = this.props;

    return (
        <table>
          <tbody>
          {azureAdList.map(data =>
              <Fragment key={data.id}>
                <tr>
                  <td className="appNameCell">
                    <p><a>{data.appName}</a></p>
                    <p className="integrationInfo">{messageConstants.MICROSOFT_AZURE_AD} {data.tenantId}</p>
                  </td>
                  <td className="scriptCell">
                    <a onClick={this.props.handleJsonClick}>{messageConstants.JSON}</a>
                  </td>
                  <td className="deleteCell">
                      <DeleteIntegrationButton deleteAction={() => deleteAzureAd(data.id)}/>
                  </td>
                </tr>
              </Fragment>
          )}
          </tbody>
        </table>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/AzureAdList/AzureAdTable.js